module.exports = __webpack_public_path__ + "static/dm-ba19accaa90ad9ec5e758576fc465e8d.svg";